import { RowAction } from './table-actions.model';
import { SortOrder } from './table-request.model';
import {
  CustomDataSearchFieldModel,
  FieldDefinitionModel,
  FieldType,
} from '@seahorse/domain';
import { PipeModel } from '@seahorse/common';
import { FormModel } from '@seahorse/forms';
import { Observable } from 'rxjs';
import {
  ProgressColorMap,
  ProgressDisplayFormat,
  ProgressDisplayType,
} from '@seahorse/ui';

export interface TableModel<TData> {
  id?: keyof TData & string;
  columns: ColumnModel<TData>[];
  serverSide: boolean;
  sortBy?: {
    field?: keyof TData & string;
    order?: SortOrder;
    sortFn?: (a: TData, b: TData) => number;
  };
  groupBy?: keyof TData & string;
  rowActions?: RowAction[];
  rowsPerPage?: number[];
  pageSize?: number;
  sortMode?: 'single' | 'multiple';
  selectionMode?: 'single' | 'multiple';
  enableFiltering?: boolean;
  disablePaging?: boolean;
  form?: FormModel<any>;
  hideFormActions?: boolean;
  suggestedRows?: Record<number, Observable<TData>>;
  editModeTrigger?: 'checkbox' | 'click';
  scrollHeight?: string;
  supportsReordering?: boolean;
  progressConfig?: {
    colorMap: ProgressColorMap[];
    format: ProgressDisplayFormat;
    type: ProgressDisplayType;
  };
}

export interface ColumnModel<TData = never> {
  key: keyof TData & string;
  name: string;
  definition?: FieldDefinitionModel;
  fieldType?: FieldType;
  order?: number;
  pipes?: PipeModel[];
  defaultValue?: any;
  styles?: Partial<CSSStyleDeclaration>;
  hidden?: boolean;
  disabled?: boolean;

  displayFields?: string[];
  appendText?: string;
  showCopyButton?: boolean;

  users?: any[]; // TODO: remove
}

export const columnFilterTypes: Record<FieldType, string> = {
  [FieldType.SingleLineText]: 'text',
  [FieldType.MultiLineText]: 'text',
  [FieldType.DateTime]: 'date',
  [FieldType.Integer]: 'numeric',
  [FieldType.Boolean]: 'boolean',
  [FieldType.List]: 'text',
  [FieldType.File]: 'text',
  [FieldType.Decimal]: 'numeric',
  [FieldType.LinkedObject]: 'text',
  [FieldType.LinkedObjects]: 'text',
  [FieldType.AutoNumbering]: 'numeric',
  [FieldType.Date]: 'date',
  [FieldType.Currency]: 'numeric',
  [FieldType.ProgressBar]: 'text',
  [FieldType.StatusCount]: 'text',
  [FieldType.Time]: 'text',
  [FieldType.Status]: 'text',
  [FieldType.MetaInformation]: 'text',
  [FieldType.Json]: 'text',
  [FieldType.Object]: 'text',
  [FieldType.ExternalObject]: 'text',
};

export interface TableActionEvent {
  action: string;
  data?: any;
}

export interface RowActionEvent<TEntity> {
  action: string;
  data: TEntity;
}

export interface TableDataLoadEvent {
  first: number;
  rows: number;
  filters: CustomDataSearchFieldModel[];
  sortField?: string;
  sortOrder?: number;
  pageIndex: number;
  pageSize: number;
}

export const DEFAULT_PAGE_SIZES = [10, 20, 50, 100];
